// hooks/useCidades.ts
import { useFetch } from "./useFetch";
import { Pais } from "../interfaces/Pais";
import { buscarPaisesService } from "../services/buscarPaisesService";

export const usePaises = () => {
  const { isLoading, data, error } = useFetch<Pais[]>(
    true,
    buscarPaisesService,
    [] // dependências
  );

  return { isLoading, data, error };
};
